import { ChangeDetectionStrategy, Component, HostBinding, HostListener, OnInit } from "@angular/core";
import { TelemetryService } from "@obg/ngx.global.evo";

@Component({
	selector: "obg-app-my-offers-lobby",
	templateUrl: "./my-offers-lobby.component.html",
	styleUrls: ["./my-offers-lobby.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyOffersLobbyComponent implements OnInit {
	@HostBinding("class.obg-app-my-offers-lobby") hostCss = true;

	constructor(private telemetryService: TelemetryService) {}

	@HostListener("document:visibilitychange", [])
	handleVisibilityChange() {
		document.visibilityState === "hidden" ? this.trackClosing() : this.trackOpening();
	}

	ngOnInit() {
		this.trackOpening();
	}

	canDeactivate(): boolean {
		this.trackClosing();
		return true;
	}

	private trackOpening(): void {
		this.trackEvent("BonusSelectionOpen", "My Offers");
	}

	private trackClosing(): void {
		this.trackEvent("BonusSelectionClick", "My Offers", "Close", "Casino");
	}

	private trackEvent(event: string, location?: string, itemClicked?: string, bonusType?: string): void {
		const optionalDetails = {
			...(location && { Location: location }),
			...(itemClicked && { ItemClicked: itemClicked }),
			...(bonusType && { BonusType: bonusType }),
		};

		this.telemetryService.track({
			event,
			...optionalDetails,
		});
	}
}
